// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Oi-z","tupacHeader":"Pi-z","tupacHeader2":"Qi-z","tupacMenu":"Ri-z","tupacMenu2":"Si-z","tupacMain":"Ti-z","tupacMain2":"Ui-z"};